import { useState } from "react";
import Web3 from 'web3';
import './App.css';

let myCHAIN = "XRPL EVM not found";
let connectedWALLET = "  ";
let buttonLABEL = " Connect Wallet "
let buttonLABEL3 = "  Z-names  "
let myContract;
let web3;
let zName;

function App() {

    const contractAddress = '0xf96a0E5124def4C4083e4e2Ce59e3B071948C237';
    const contractABI = [{ "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "address", "name": "owner", "type": "address" }], "name": "ERC721IncorrectOwner", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "operator", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "ERC721InsufficientApproval", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "approver", "type": "address" }], "name": "ERC721InvalidApprover", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "operator", "type": "address" }], "name": "ERC721InvalidOperator", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }], "name": "ERC721InvalidOwner", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "receiver", "type": "address" }], "name": "ERC721InvalidReceiver", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }], "name": "ERC721InvalidSender", "type": "error" }, { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "ERC721NonexistentToken", "type": "error" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "approved", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "operator", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "approved", "type": "bool" }], "name": "ApprovalForAll", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "inputs": [{ "internalType": "uint256", "name": "EN_ID", "type": "uint256" }], "name": "Claim_End_Name", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "_front_name", "type": "string" }, { "internalType": "string", "name": "_end_name", "type": "string" }, { "internalType": "address payable", "name": "Interface_Owner", "type": "address" }], "name": "Claim_Name", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "_token_id", "type": "uint256" }, { "internalType": "uint256", "name": "_index", "type": "uint256" }, { "internalType": "string", "name": "_metadata", "type": "string" }], "name": "Edit_Metadata", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "End_Name_Price", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" }], "name": "NFT_metadata", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "EN_ID", "type": "uint256" }, { "internalType": "address payable", "name": "new_owner", "type": "address" }], "name": "Transfer_End_Name", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "approve", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "getApproved", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "end_name", "type": "string" }], "name": "get_EN_index", "outputs": [{ "internalType": "uint256", "name": "EN_index", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "z_name", "type": "string" }], "name": "get_NFT_index", "outputs": [{ "internalType": "uint256", "name": "z_index", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "token_index", "type": "uint256" }], "name": "get_NFT_metadata", "outputs": [{ "internalType": "string", "name": "meta_0", "type": "string" }, { "internalType": "string", "name": "meta_1", "type": "string" }, { "internalType": "string", "name": "meta_2", "type": "string" }, { "internalType": "string", "name": "meta_3", "type": "string" }, { "internalType": "string", "name": "meta_4", "type": "string" }, { "internalType": "string", "name": "meta_5", "type": "string" }, { "internalType": "string", "name": "meta_6", "type": "string" }, { "internalType": "string", "name": "meta_7", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "operator", "type": "address" }], "name": "isApprovedForAll", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "mint_count", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "mint_price", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "ownerOf", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "z_name", "type": "string" }], "name": "resolver", "outputs": [{ "internalType": "address", "name": "z_owner", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "operator", "type": "address" }, { "internalType": "bool", "name": "approved", "type": "bool" }], "name": "setApprovalForAll", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "bytes4", "name": "interfaceId", "type": "bytes4" }], "name": "supportsInterface", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "tokenURI", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "tokenId", "type": "uint256" }], "name": "transferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "vault", "outputs": [], "stateMutability": "nonpayable", "type": "function" }]; // Your contract's ABI array


    const [frontName, setFrontName] = useState('z-names')
    const [endName, setEndName] = useState('com')
    const [chainID, setChainID] = useState('Network not connected')
    let [searchResults, setSearchResults] = useState(' ')
    let [chosenMetadata, setChosenMetadata] = useState('2')
    let [metadataContent, setMetadataContent] = useState(' ')
    const [metaData1, setMetaData1] = useState(' ')
    const [metaData2, setMetaData2] = useState(' ')
    const [metaData3, setMetaData3] = useState(' ')
    const [metaData4, setMetaData4] = useState(' ')
    const [metaData5, setMetaData5] = useState(' ')
    const [metaData6, setMetaData6] = useState(' ')
    const [metaData7, setMetaData7] = useState(' ')
    const [metaData8, setMetaData8] = useState(' ')



    // Function to connect to the injected provider
    
    async function connectWallet() {
        if (window.ethereum) {
            try {
                // Request account access if needed
                await window.ethereum.request({ method: 'eth_requestAccounts' });

                // Initialize Web3 with the injected provider
                web3 = new Web3(window.ethereum);
                console.log('Connected to injected provider (e.g., MetaMask)');

                // You can now interact with the blockchain using the web3 instance
                const accounts = await web3.eth.getAccounts();
                console.log('Accounts:', accounts);
                const chainId = await web3.eth.getChainId();
                console.log('Chain ID:', chainId);
                myCHAIN = chainId;
                connectedWALLET = accounts[0];
                if (myCHAIN == 1440000) {
                    buttonLABEL = " CONNECTED ";
                    setChainID(myCHAIN);
                }

            } catch (error) {
                console.error('User denied account access or an error occurred:', error);
            }
        } else {
            console.warn('No injected Ethereum provider found. Please install MetaMask or a similar wallet.');
            myCHAIN = "network pending...";
        }
        setChainID(myCHAIN);
    }


    async function search_Zname() {

        setMetaData1(" ");
        setMetaData2(" ");
        setMetaData3(" ");
        setMetaData4(" ");
        setMetaData5(" ");
        setMetaData6(" ");
        setMetaData7(" ");
        setMetaData8(" ");

        if (web3) {
            myContract = new web3.eth.Contract(contractABI, contractAddress);

            if (myContract) {
                try {
                    setSearchResults("NO MATCH FOUND");
                    buttonLABEL3 = "  CLAIM NAME  ";
                    zName = frontName + "." + endName;
                    const result = await myContract.methods.get_NFT_index(zName).call();
                    console.log("Value from contract:", result);

                    if (result != "error") {
                        buttonLABEL3 = " NFT INDEX # " + result + " ";
                        setSearchResults(result);
                        const meta1 = await myContract.methods.NFT_metadata(result, 0).call();
                        setMetaData1(meta1);
                        const meta2 = await myContract.methods.NFT_metadata(result, 1).call();
                        setMetaData2(meta2);
                        const meta3 = await myContract.methods.NFT_metadata(result, 2).call();
                        setMetaData3(meta3);
                        const meta4 = await myContract.methods.NFT_metadata(result, 3).call();
                        setMetaData4(meta4);
                        const meta5 = await myContract.methods.NFT_metadata(result, 4).call();
                        setMetaData5(meta5);
                        const meta6 = await myContract.methods.NFT_metadata(result, 5).call();
                        setMetaData6(meta6);
                        const meta7 = await myContract.methods.NFT_metadata(result, 6).call();
                        setMetaData7(meta7);
                        const meta8 = await myContract.methods.NFT_metadata(result, 7).call();
                        setMetaData8(meta8);

                    } else {
                        searchResults = "NO MATCH FOUND";
                        setSearchResults("NO MATCH FOUND");                        
                    }
                    

                } catch (error) {
                    console.error("Error calling view function:", error);
                }
            } else {
                console.error("Contract not initialized.");
            }

        } else {
            console.error("Wallet Not Connected.");
        }
        
    }

    async function claim_Zname() {

        if (web3 && myContract) {
            if (metaData1 == " ") {

                try {
                    await myContract.methods.Claim_Name(frontName, endName, "0xD6a6e218b740375C54E3854550BF1974a2747672").send({ from: connectedWALLET, value: 5000000000000000000 });
                    console.log("Transaction sent successfully!");
                } catch (error) {
                    console.error("Error writing to contract:", error);
                }
            } else {
                console.error("Error writing to contract: Your Z-name is not available.");
            }
        } else {
            console.error("Error writing to contract: Connect Wallet & Search Z-name first.");
        }

 
    }


    async function updateMetadata() {

        if (searchResults != " " && searchResults != "NO MATCH FOUND") {
            if (myContract) {
                const nftOwner = await myContract.methods.ownerOf(searchResults).call();
                if (nftOwner == connectedWALLET) {

                try {
                    await myContract.methods.Edit_Metadata(searchResults, chosenMetadata, metadataContent).send({ from: connectedWALLET, value: 0 });
                    console.log("Transaction sent successfully!");
                } catch (error) {
                    console.error("Error writing to contract:", error);
                }

                } else {
                    console.error("Error writing to contract: UNAUTHORIZED ACCESS! \n The connected wallet is not the owner of the Z-name Web3 Domain's NFT. So, you cannot edit the NFT's Metadata. \n ACCESS DENIED!");
                }
            } else {
                console.error("Error writing to contract: Need to connect wallet first, then search a Z-name for a match to get the NFT Index #.");
            }

        } else {
            console.error("Error writing to contract: Need a Match for SEARCH results first for an NFT Index # before you can edit the metadata for the Z-name Web3 Domain.");

        }

    }



  return (
    <div className="App">
          <header className="App-header">

              <br></br>
              
              <div id="custom_Display">
                    
                  {myCHAIN}
                  <br></br>
                  {myCHAIN == 1440000 ? "XRPL EVM Sidechain" : "Wrong Network!"}
                  
              </div>
              
              <input type="button" name="connect-button" value={buttonLABEL} onClick={connectWallet} className="connect-button" />
             

              <font size='3'>
                  {connectedWALLET}
              </font>

              <br></br>
              <table style={{ backgroundColor: '#000000', borderColor: '#dddddd' }} border='5' cellPadding='10' cellSpacing='0' >
                  <thead>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
              <img src="znames_com.svg" alt="Z-names.com" width='128' height='128' align='left' />
                    </td>
                    <td>
                      <font size='6'>
                      Web3 Domains
                      <br></br>
                      Decentralized
                      <br></br>
                      & Uncensored
                      </font>
                    </td>
                  </tr>
                  </tbody>
              </table>

              <p>
                  Front Name : <input type="text" value={frontName} className="text-inputs" size='10' onChange={e => setFrontName(e.target.value)} />
              <br></br>
                  End Name : <input type="text" value={endName} className="text-inputs" size='12' onChange={e => setEndName(e.target.value)} />
              </p>

              <font color='00ff00'>
                  <div>
                  {frontName}.{endName}
                  <br></br>
                  </div>

              </font>
              <input type="button" id="search-button" value="  SEARCH  " onClick={search_Zname} className="connect-button" />
              

              {/* {searchResults} 
              <br></br>
              */}

              <div>

              <input type="button" id="claim_button" value={buttonLABEL3} onClick={claim_Zname} className="connect-button"/>

              <br></br>
                  {/*  {metaData1} */}
              <p></p>
              <div dangerouslySetInnerHTML={{ __html: metaData2 }} />
              <p></p>
              {metaData3}
              <p></p>
              {metaData4}
              <p></p>
              {metaData5}
              <p></p>
              {metaData6}
              <p></p>
              {metaData7}
              <p></p>
              {metaData8}
              <p></p>

              
                  <input type="button" id="edit-metadata" value="  EDIT METADATA  " onClick={updateMetadata} className="connect-button" />
                  <br></br>
                  
                  <select id="nft-index-number" defaultValue="1" onChange={e => setChosenMetadata(e.target.value)} className="text-inputs">
                      <option value="2">1</option>
                      <option value="3">2</option>
                      <option value="4">3</option>
                      <option value="5">4</option>
                      <option value="6">5</option>
                      <option value="7">6</option>
                  </select>
                  <br></br>
                  <textarea id="metadata-chosen" style={{ width: '400px', height: '200px' }} onChange={e => setMetadataContent(e.target.value)} className="text-inputs" />     

              </div>

      </header>
    </div>
  );
}

export default App;
